import React from 'react';
import { Box, TextField, IconButton } from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

interface DynamicInputFieldProps {
  index: number;
  inputField: { name: string; value: string | number };
  handleChangeInput: (
    index: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  handleRemoveFields: (index: number) => void;
  handleAddFields: () => void;
}

const DynamicInputField: React.FC<DynamicInputFieldProps> = ({
  index,
  inputField,
  handleChangeInput,
  handleRemoveFields,
  handleAddFields,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: 2,
        mb: 2,
        alignItems: 'center',
      }}
    >
      <TextField
        name="name"
        label="Name"
        variant="standard"
        fullWidth
        value={inputField.name}
        onChange={(event) => handleChangeInput(index, event)}
      />
      <TextField
        name="value"
        label="Value"
        variant="standard"
        fullWidth
        value={inputField.value}
        onChange={(event) => handleChangeInput(index, event)}
      />
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton onClick={() => handleRemoveFields(index)} size="large">
          <RemoveIcon />
        </IconButton>
        <IconButton onClick={handleAddFields} size="large">
          <AddIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default DynamicInputField;
